import { Badge, Box, Divider, Flex, Text } from '@chakra-ui/react';
import useChatLastMessageDate from 'hooks/modules/chat/useChatLastMessageDate';
import useChatName from 'hooks/modules/chat/useChatName';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';
import ChatListLastMessageText from './ChatListLastMessageText';

import ChatRoomThumbnail from 'presentation/components/modules/chat/ChatRoomThumbnail';
import { ChatDetailModel } from 'model/modules/chat/chatList';

interface Props extends ChatDetailModel {
  onClick: () => void;
  isSelected: boolean;
  chatName: string | null;
}

const ChatListItem: FC<Props> = ({
  type,
  members,
  chatName,
  lastMessage,
  unreadMessageCount,
  icon,
  onClick,
  isSelected,
}) => {
  const lastMessageDate = useChatLastMessageDate(
    lastMessage?.createdAt ?? null
  );

  const name = chatName ?? useChatName(type);

  return (
    <Box
      px="20px"
      w="100%"
      overflow="hidden"
      cursor="pointer"
      backgroundColor={isSelected ? Color.Shade200 : undefined}
      _hover={{ backgroundColor: Color.Shade200 }}
      onClick={onClick}
    >
      <Flex alignItems="center" py="10px" minW={0}>
        <Box mr="10px" flexShrink={0}>
          <ChatRoomThumbnail
            size="60px"
            avatar={icon?.url ?? ''}
            roomType={type}
          />
        </Box>
        <Box flex="1" minW={0}>
          <Flex alignItems="center" justifyContent="space-between" minW={0}>
            <Text
              noOfLines={1}
              fontWeight={600}
              fontSize="18px"
              flex="1"
              minW={0}
            >
              {name}
            </Text>
            {lastMessage && (
              <Text ml="10px" flexShrink={0}>
                {lastMessageDate}
              </Text>
            )}
          </Flex>
          {lastMessage && (
            <Flex justifyContent="space-between" mt="5px" minW={0}>
              <ChatListLastMessageText lastMessage={lastMessage} />
              {unreadMessageCount > 0 && (
                <Box ml={4} flexShrink={0}>
                  <Badge
                    px={2}
                    backgroundColor={Color.Primary500}
                    color={Color.OnPrimary}
                    borderRadius={10}
                  >
                    {unreadMessageCount}
                  </Badge>
                </Box>
              )}
            </Flex>
          )}
        </Box>
      </Flex>
      <Divider />
    </Box>
  );
};

export default ChatListItem;
